import { useState } from "react";

export default function StudentList({ students, onDelete, onHide, onShow }) {
  const [openMenuId, setOpenMenuId] = useState(null);
  if (!students || students.length === 0) {
    return <p className="ct-panel-subtitle">Nog geen leerlingen.</p>;
  }

  return (
    <div className="ct-side-list">
      {students.map((student) => (
        <div
          key={student.id}
          className={`ct-side-row ct-student-admin-row${student.hidden_from_class ? " is-hidden" : ""}`}
        >
          <span className="ct-student-admin-name">
            {student.student_name}
            {student.hidden_from_class && <span className="ct-hidden-label">Verborgen</span>}
          </span>
          <div className="ct-student-menu-wrap">
            <button
              type="button"
              onClick={() => setOpenMenuId(openMenuId === student.id ? null : student.id)}
              className="ct-overflow-button"
              title={`Acties voor ${student.student_name}`}
              aria-label={`Acties voor ${student.student_name}`}
              aria-haspopup="menu"
              aria-expanded={openMenuId === student.id}
            >
              ⋯
            </button>
            {openMenuId === student.id && (
              <div className="ct-student-menu" role="menu">
                <button
                  type="button"
                  role="menuitem"
                  onClick={() => {
                    (student.hidden_from_class ? onShow : onHide)(student.id);
                    setOpenMenuId(null);
                  }}
                >
                  {student.hidden_from_class ? "Weer tonen" : "Verbergen"}
                </button>
                <button
                  type="button"
                  role="menuitem"
                  className="is-danger"
                  onClick={() => {
                    onDelete(student.id);
                    setOpenMenuId(null);
                  }}
                >
                  Verwijderen
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
